import { Box, Stack, TextField, Theme } from '@mui/material';
import { ChangeEvent, FC, useState } from 'react';
import { createUseStyles } from 'react-jss';
import Icon from '@/components/icon';

const useStyles = createUseStyles<string, { open: boolean }>((theme: Theme) => ({
  searchInput: {
    '& .MuiInputBase-root': {
      paddingRight: 6,
      '&.Mui-focused': {
        '& fieldset': {
          borderWidth: 1,
          borderColor: theme.palette.divider,
        },
      },
      '& input.MuiInputBase-input': {
        padding: '5px 6px',
        fontSize: '0.75rem',
      },
    },
  },
  openButton: {
    height: 20,
  },
}));

interface Props {
  value: string;
  onChange?: (value: string, event?: ChangeEvent<HTMLInputElement>) => void;
  onChangeOpen?: (open: boolean) => void;
}

const SearchInput: FC<Props> = ({ onChange, onChangeOpen, value }) => {
  const [open, setOpen] = useState(false);
  const styles = useStyles({ open });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(String(event.target.value), event);
  };

  const handleToggleOpen = () => {
    const updated = !open;
    if (!updated) {
      onChange?.('', undefined);
    }

    setOpen(updated);
    onChangeOpen?.(updated);
  };

  if (!open) {
    return (
      <Stack alignItems="center" justifyContent="center" height="32px">
        <Icon size="small" name="search" onClick={handleToggleOpen} />
      </Stack>
    );
  }

  return (
    <Box width="150px">
      <TextField
        variant="outlined"
        onChange={handleChange}
        value={value}
        margin="none"
        fullWidth
        autoFocus
        type="text"
        className={styles.searchInput}
        size="small"
        inputProps={{ maxLength: 25 }}
        InputProps={{
          endAdornment: <Icon size="small" name="close" onClick={handleToggleOpen} />,
        }}
      />
    </Box>
  );
};

export default SearchInput;
